package net.frozenbit.games.soundgame.utils

import io.ktor.util.toByteArray
import kotlinx.coroutines.await
import org.khronos.webgl.ArrayBuffer
import org.khronos.webgl.Int8Array
import org.w3c.dom.HTMLCanvasElement
import org.w3c.files.Blob
import qrcode.render.QRCodeGraphics
import kotlin.coroutines.suspendCoroutine
import kotlin.js.JsName
import kotlin.js.Promise

@JsName("Blob")
private external class MyBlob : Blob {
    fun arrayBuffer(): Promise<ArrayBuffer>
}

actual suspend fun QRCodeGraphics.pngBytes(): ByteArray? {
    try {
        return suspendCoroutine { continuation ->
            try {
                (nativeImage() as HTMLCanvasElement)
                    .toBlob(
                        _callback = { blob ->
                            continuation.resumeWith(Result.success(blob as MyBlob))
                        }
                    )
            } catch (e: Exception) {
                continuation.resumeWith(Result.failure(e))
            }
        }
            .arrayBuffer()
            .await()
            .let { buffer ->
                Int8Array(buffer).toByteArray()
            }

    } catch (e: Exception) {
        e.printStackTrace()
        return null
    }
}